var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.882 2.93L11.5245 2.164C10.9038 1.6386 10.1962 1.22557 9.4335 0.9435L9.092 1.8825C9.74503 2.12471 10.3508 2.47953 10.882 2.93Z",
    fill: "#350A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.905 6.5L13.889 6.2935C13.7506 5.49466 13.4734 4.72622 13.07 4.023L12.2045 4.5C12.55 5.12201 12.7869 5.79837 12.905 6.5Z",
    fill: "#350A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.092 13.1175L9.4335 14.0565C10.1962 13.7746 10.9038 13.3617 11.5245 12.8365L10.882 12.0705C10.3508 12.521 9.74503 12.8753 9.092 13.1175Z",
    fill: "#350A7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2045 10.5L13.07 11C13.4736 10.2886 13.7507 9.51262 13.889 8.7065L12.905 8.533C12.7868 9.22418 12.5498 9.88967 12.2045 10.5Z",
    fill: "#350A7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5V0.5C5.14348 0.5 3.36301 1.2375 2.05025 2.55025C0.737498 3.86301 0 5.64348 0 7.5C0 9.35652 0.737498 11.137 2.05025 12.4497C3.36301 13.7625 5.14348 14.5 7 14.5Z",
    fill: "#350A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.7e558da485217256126ae89c7c7d83a1.svg";
export { ForwardRef as ReactComponent };